exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider[data-v-18c11510]{margin:120px 30% 0}.articles[data-v-18c11510]{width:948px;margin:20px auto 0;list-style:none;padding:0;position:relative}.btn-change[data-v-18c11510]{text-align:center;margin-top:30px;margin-bottom:120px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18c11510","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/web/components/index/articles.vue
// module id = 111
// module chunks = 1